import {Stack, Typography} from '@mui/material';
import React, {memo, useEffect} from 'react';

import {TypeLocalNameEnum} from 'domain/usecases';
import {OdontoBookingTaggingEnum} from 'main/analytics/gaTagsEnum';

import {useBookingStore} from 'presentation/modules/booking/shared/store/useBookingStore';
import {useQueryParams} from 'presentation/pages/private/hooks';
import {translations} from 'presentation/translations-new';
import {DistrictCheckbox} from '../DistrictCheckbox';
import {StyledDistrictGrid} from './styles';
import {DistrictCheckboxProps} from './types';

const {selectDistrict, all, selectAll, resultFound} = translations['pt-br'].commons;

export const DistrictList = memo(
	({list, handleSelectCard, selectedDistricts}: DistrictCheckboxProps) => {
		const bookingData = useBookingStore(state => state.bookingData);
		const {allDistrictsSelected, typeLocalName, districtName} = bookingData;
		const showCityName = typeLocalName === TypeLocalNameEnum.ZONA;

		const {SEARCH_PARAMS} = useQueryParams();
		const {query} = SEARCH_PARAMS;

		useEffect(() => {
			if (!districtName) {
				handleSelectCard(`${all}-${selectAll}`, true);
			}
		}, []);

		return (
			<Stack gap={2}>
				{query ? (
					<Typography variant="subtitle2" color="text.secondary">
						{resultFound}
					</Typography>
				) : null}

				<Typography variant="subtitle2" color="text.secondary">
					{selectDistrict}
				</Typography>
				<Stack gap={2}>
					<StyledDistrictGrid>
						{query ? null : (
							<DistrictCheckbox
								handleSelectCard={handleSelectCard}
								checked={!!allDistrictsSelected}
								district={all}
								city={selectAll}
								query={''}
								allDistrictsSelected={false}
								showCityName={showCityName}
							/>
						)}

						{list.map(item => (
							<DistrictCheckbox
								districtDataTagId={`${OdontoBookingTaggingEnum.CLICK_SELECIONAR_BAIRRO_ODONTO}`}
								key={`${item.district}-${item.city}`}
								handleSelectCard={handleSelectCard}
								checked={selectedDistricts.includes(
									`${item.district}-${item.city}`,
								)}
								district={item.district}
								city={item.city}
								query={query}
								allDistrictsSelected={allDistrictsSelected}
								showCityName={showCityName}
							/>
						))}
					</StyledDistrictGrid>
				</Stack>
			</Stack>
		);
	},
);
